import type { LucideIcon } from "lucide-react";
import {
  Shield,
  DollarSign,
  Users,
  MapPin,
  Lock,
  Handshake,
} from "lucide-react";

export type Benefit = {
  icon: LucideIcon;
  title: string;
  description: string;
};

export const benefits: Benefit[] = [
  {
    icon: Shield,
    title: "Analise gratuita do contrato",
    description:
      "Nossos advogados analisam seu contrato sem custo inicial para identificar cobranças indevidas e juros abusivos.",
  },
  {
    icon: DollarSign,
    title: "Recuperacao de valores",
    description:
      "Atuamos para recuperar os valores pagos a mais em contratos com taxas acima do permitido pelo mercado.",
  },
  {
    icon: Users,
    title: "Advogados especializados",
    description:
      "Equipe com experiencia em direito bancario e revisao contratual, com historico comprovado de resultados.",
  },
  {
    icon: MapPin,
    title: "Atendimento em todo Brasil",
    description:
      "Atendemos clientes de qualquer estado brasileiro, com suporte online completo e acessivel.",
  },
  {
    icon: Lock,
    title: "Sigilo total",
    description:
      "Todas as informacoes do seu caso sao tratadas com total confidencialidade e protegidas pelo sigilo profissional.",
  },
  {
    icon: Handshake,
    title: "Sem custo inicial",
    description:
      "A avaliacao do seu contrato e gratuita. Voce so paga se decidir seguir com a acao de revisao contratual.",
  },
];
